/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class SettingsAPI extends ApiClient {
  constructor() {
    super('kanban/settings', { accountScoped: true, apiVersion: 'v1' });
  }

  get() {
    return axios.get(this.url);
  }

  update(settings) {
    return axios.put(this.url, { settings });
  }
}

export default new SettingsAPI();
